import { useContext } from "react";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Navbar from "./components/navbar/Navbar";
import Intro from "./components/intro/Intro";
import ProductList from "./components/productList/ProductList";
import { ThemeContext } from "./context";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "./components/notfound/NotFound";

function App() {
  const theme = useContext(ThemeContext);
  const dark = theme.state.darkMode;

  return (
    <div
      style={{
        backgroundColor: dark ? "#222" : "white",
        color: dark && "white",
        marginTop: "-15px",
        overflow: "hidden",
      }}
    >
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<ProductList />} />
          <Route path="/" element={<Intro />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

      <Footer />
    </div>
  );
}

export default App;
